<template>
  <v-dialog v-model="model" max-width="500px">
    <v-card>
      <v-card-title class="modal-chat__title">
        <span>{{ modalTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container v-if="selectedMessage && selectedItem" grid-list-md>
          <v-layout v-if="action === 'edit'" wrap>
            <v-flex xs12 sm6 md12>
              <v-text-field v-model="selectedMessage.message.user_name" label="Автор сообщения" disabled />
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field v-model="selectedMessage.date" label="Дата" disabled />
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field v-model="selectedMessage.time" label="Время" disabled />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="message"
                box
                color="accent"
                name="input-7-4"
                label="Текст сообщения"
              />
            </v-flex>
          </v-layout>
          <v-flex
            v-if="action === 'delete'"
            class="modal-chat__confirm"
            xs12
            sm6
            md12
          >
            Вы уверены, что хотите удалить соообщение?
          </v-flex>
          <v-layout v-if="action === 'block'" wrap>
            <v-flex xs12 sm6 md12>
              <v-text-field v-model="selectedMessage.message.user_name" label="Автор сообщения" disabled />
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field v-model="blockTime" color="accent" label="Кол-во минут" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Отмена</v-btn>
        <v-btn v-if="action === 'edit'" text @click="changeMessage">Сохранить</v-btn>
        <v-btn v-if="action === 'delete'" text @click="deleteMessage">Удалить</v-btn>
        <v-btn v-if="action === 'block'" text @click="blockUser">Заблокировать</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { baseURL } from '../../api/config'

export default {
  name: 'MessageModal',
  props: ['selectedItem', 'modalTitle', 'action', 'showModal'],
  data: () => ({
    model: false,
    selectedMessage: null,
    message: '',
    blockTime: 0,
    alertText: ''
  }),
  watch: {
    model (val) {
      if (!val) {
        this.message = this.selectedItem.message.body
        this.$emit('close')
      }
    },
    showModal (val) {
      this.model = val
    },
    selectedItem () {
      this.selectedMessage = this.selectedItem
      this.message = this.selectedItem.message.body
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    blockUser () {
      const url = `${baseURL}/chats/catcher/blacklist`
      axios
        .post(url, {
          user: this.selectedMessage.message.user_id,
          minutes: this.blockTime
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.alertText = `Пользователь ${this.selectedMessage.message.user_name} успешно добавлен в черный список!`
          EventBus.$emit('message-emit', this.alertText)
          this.close()
        })
    },
    deleteMessage (item) {
      const url = `${baseURL}/chats/messages/${this.selectedMessage.message.id}`
      axios
        .delete(url)
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.alertText = 'Сообщение успешно удалено!'
          EventBus.$emit('message-emit', this.alertText)
          EventBus.$emit('message-delete')
          this.close()
        })
    },
    changeMessage () {
      const url = `${baseURL}/chats/messages/${this.selectedMessage.message.id}`
      axios
        .put(url, {
          body: this.message
        })
        .then(response => {
          this.selectedMessage.message.body = this.message
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.alertText = 'Сообщение отредактировано успешно!'
          EventBus.$emit('message-emit', this.alertText)
          this.close()
        })
    }
  }
}
</script>
